import { List, Grid2X2, Grid3X3 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ViewType } from "./types";

interface ViewSwitcherProps {
  viewType: ViewType;
  setViewType: (type: ViewType) => void;
}

export function ViewSwitcher({ viewType, setViewType }: ViewSwitcherProps) {
  return (
    <div className="flex items-center rounded-md border bg-muted p-1">
      <Button
        variant={viewType === 'list' ? 'default' : 'ghost'}
        size="sm"
        className="h-8 w-8 p-0 transition-colors duration-200"
        onClick={() => setViewType('list')}
      >
        <List className="h-4 w-4" />
      </Button>
      <Button
        variant={viewType === 'grid-2' ? 'default' : 'ghost'}
        size="sm"
        className="h-8 w-8 p-0 transition-colors duration-200"
        onClick={() => setViewType('grid-2')}
      >
        <Grid2X2 className="h-4 w-4" />
      </Button>
      <Button
        variant={viewType === 'grid-3' ? 'default' : 'ghost'}
        size="sm"
        className="h-8 w-8 p-0 transition-colors duration-200"
        onClick={() => setViewType('grid-3')}
      >
        <Grid3X3 className="h-4 w-4" />
      </Button>
    </div>
  );
}